// extracted by mini-css-extract-plugin
module.exports = {"page":"layout-module--page--3OkPY","page_dark":"layout-module--page_dark--2B6-K"};